import { render, staticRenderFns } from "./ExamSessionsWidget.vue?vue&type=template&id=25f08597"
import script from "./ExamSessionsWidget.vue?vue&type=script&lang=js"
export * from "./ExamSessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f08597')) {
      api.createRecord('25f08597', component.options)
    } else {
      api.reload('25f08597', component.options)
    }
    module.hot.accept("./ExamSessionsWidget.vue?vue&type=template&id=25f08597", function () {
      api.rerender('25f08597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/ExamSessionsWidget.vue"
export default component.exports